module.exports = __webpack_public_path__ + "std/img/raffle-record.251362c.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build800/assets/image/raffle-record.png
// module id = LJLU
// module chunks = 0 5